export default "__VITE_ASSET__CbEVUxxN__"